export default __webpack_public_path__ + "static/media/plan-s1.145bedf2.svg";